import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Bem from 'bemHelper';
import { I18nHoc, Trans } from 'helpers/i18n';
import Row, { Col } from 'components/row';

import translates from '../how-we-calculate-score-i18n';

const classes = new Bem('blockExpertMustConfirm');

@I18nHoc(translates())
export default class ExpertMustConfirmBlock extends Component {
  static propTypes = {
    className: PropTypes.string
  };

  render() {
    const { className } = this.props;

    return (
      <div {...classes({ extra: className })}>
        <Trans lang="ru">
          <Row {...classes('row', 'block')} mtColumn mpColumn>
            <Col {...classes('col', 'info')} allPr={0}>
              <div {...classes('text', 'h2')}><h2 children="Эксперт обязательно подтверждает своё решение об оценке каждого пункта отчёта скриншотами документов или ссылками на Закон Украины или документы." /></div>
              <div {...classes('description')}>
                <p {...classes('text', 'description')} children="Эксперт не просто приводит ссылку на документ, предоставляя вам возможность самостоятельно вычитывать, находить нужные части и интерпретировать данные, а заботливо выделит на скриншоте именно ту часть документа, которая важна для ответа на вопрос пункта оценки и, при необходимости, сопроводит пункт своим комментарием." />
              </div>
            </Col>
            <Col {...classes('col', 'list')} allPr={0}>
              <div {...classes('itemTopic')}>
                <div {...classes('text', 'h3')}>
                  <h3 children="Баллы за каждый пункт строго регламентированы" />
                </div>
              </div>
              <div {...classes('description')}>
                <p {...classes('text', 'description')} children="Эксперт не может менять вес какого-либо пункта, а может лишь давать позитивный или негативный ответ на вопрос пункта." />
              </div>
              <div {...classes('itemTopic')}>
                <div {...classes('text', 'h3')}>
                  <h3 children="Все пункты отчёта обязательны к заполнению" />
                </div>
              </div>
              <div {...classes('description')}>
                <p {...classes('text', 'description')} children="Отчёт и Индекс надёжности не могут быть опубликованы на сайте, если в отчёте не заполнен хотя бы один пункт." />
              </div>
            </Col>
          </Row>
        </Trans>
        <Trans lang="ua">
          <Row {...classes('row', 'block')} mtColumn mpColumn>
            <Col {...classes('col', 'info')} allPr={0}>
              <div {...classes('text', 'h2')}><h2 children="Експерт обов'язково підтверджує своє рішення про оцінку кожного пункту звіту скриншотами документів або посиланнями на Закон України чи документи." /></div>
              <div {...classes('description')}>
                <p {...classes('text', 'description')} children="Експерт не лише наводить посилання на документ, надаючи вам можливість самостійно вичитувати, знаходити потрібні частини і інтерпретувати дані, а дбайливо виділить на скриншоті саме ту частину документа, яка важлива для відповіді на запитання пункту оцінки і, за необхідності, супроводить пункт своїм коментарем." />
              </div>
            </Col>
            <Col {...classes('col', 'list')} allPr={0}>
              <div {...classes('itemTopic')}>
                <div {...classes('text', 'h3')}>
                  <h3 children="Бали за кожен пункт суворо регламентовані" />
                </div>
              </div>
              <div {...classes('description')}>
                <p {...classes('text', 'description')} children="Експерт не може змінювати вагу будь-якого пункту, а може лише давати позитивну або негативну відповідь на запитання пункту." />
              </div>
              <div {...classes('itemTopic')}>
                <div {...classes('text', 'h3')}>
                  <h3 children="Усі пункти звіту обов'язкові до заповнення" />
                </div>
              </div>
              <div {...classes('description')}>
                <p {...classes('text', 'description')} children="Звіт і Індекс надійності не можуть бути опубліковані на сайті, якщо в звіті не заповнений хоча б один пункт." />
              </div>
            </Col>
          </Row>
        </Trans>
      </div>
    );
  }
}
